/* eslint-disable no-unused-vars */
import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import map from '../static/map.png'
import {
  Header,
  HeaderParagraph,
  Product,
  Backgroundwrapper,
  Footer,
  OurClient,
  ProductDescription,
  CardComponent,
  MobileFooter,
  BodyWrapper,
  Input,
  Icon
} from '../components'
import { Element } from 'react-scroll'
import { Container, BigCircle, Font51, Font20 } from '../components/StyledComponents'
const MobileClientLogo = styled.li``
const ContentWrapper = styled.div`
  max-width: 2560px;
  margin: 0 auto;
`

const TopWrapper = styled.div`
  max-width: 1366px;
  margin: 0 auto;
  @media (max-width: 768px) {
    padding: 40px 16px 20px;
    & > h1 {
      font-size: 28px !important;
      line-height: normal !important;
      letter-spacing: normal !important;
    }
    & > p {
      font-size: 16px !important;
      font-weight: 300 !important;
      line-height: 1.38 !important;
      letter-spacing: 0.1px !important;
    }
  }
  @media (max-width: 640px) {
    padding-left: 10px;
    padding-right: 10px;
  }
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 80px 250px 60px 80px;
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  & > p {
    text-align: left;
    padding: 0;
    padding-top: 10px;
    font-size: 18px;
    font-weight: 300;
    line-height: 1.61;
  }
  & > h1 {
    font-size: 48px;
    line-height: 1.27;
    color: #333333;
  }
`
const ImageWrapper = styled.div`
  & > img {
    width: 100%;
    height: 400px;
    object-fit: cover;
  }
  @media (max-width: 768px) {
    & > img {
      height: 200px;
    }
  }
`
const SpecializationWrapper = styled.div`
  width: 100%;
  max-width: 1366px;
  padding: 0 80px;
  @media (max-width: 992px) {
    padding: 0;
  }
  @media (max-width: 768px) {
    padding-top: 30px;
    & > div {
      flex-wrap: wrap;
      & > div {
        padding: 40px 20px !important;
      }
    }
  }
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 80px;
  & > div:nth-child(1) {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    & > div:nth-child(1) {
      border-right: none;
      border-left: none;
      border-top: none;
    }
    & > div:nth-child(2) {
      border-top: none;
    }
    & > div:nth-child(3) {
      border-right: none;
      border-left: none;
      border-top: none;
    }
    & > div:nth-child(4) {
      border: none;
    }
    & > div:nth-child(5) {
      border-bottom: none;
      border-top: none;
    }
    & > div:nth-child(6) {
      border: none;
    }
    @media (max-width: 768px) {
      & > div:nth-child(1) {
        border-right: none;
        border-left: none;
        border-top: none;
      }
      & > div:nth-child(2) {
        border-top: none;
        border-right: none;
      }
      & > div:nth-child(3) {
        border-right: none;
        border-left: none;
        border-top: none;
      }
      & > div:nth-child(4) {
        border: none;
        border-left: 1px solid #f0ecec;
        border-bottom: 1px solid #f0ecec;
      }
      & > div:nth-child(5) {
        border: none;
      }
      & > div:nth-child(6) {
        border: none;
        border-left: 1px solid #f0ecec;
      }
    }
    @media (max-width: 520px) {
      & > div:nth-child(1) {
        border-top: 1px solid #f0ecec;
      }
      & > div {
        border-bottom: 1px solid #f0ecec !important;
        border-right: 1px solid #f0ecec !important;
        border-left: 1px solid #f0ecec !important;
      }
    }
  }
`
const ContainerTitle = styled.h1`
  font-size: 38px;
  line-height: 1.21;
  text-align: ${props => (props.align ? props.align : 'center')};
  color: #333333;
  padding-bottom: 10px;

  @media (max-width: 768px) {
    font-size: 28px;
  }
`
const ContainerSubTitle = styled.p`
  font-size: 17px;
  font-weight: 300;
  line-height: 1.53;
  text-align: center;
  color: #999999;
  width: calc(100% - 0%);
  padding-left: 15%;
  padding-right: 15%;
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  @media (max-width: 768px) {
    font-size: 16px;
    font-weight: 300;
    padding: 0;
    line-height: 1.63;
  }
  @media (max-width: 520px) {
  padding: 0;
`
const Container2 = styled.section`
  padding: ${props => (props.padding ? props.padding : '60px 80px')};
  background: ${props => (props.background ? props.background : '#fff')};
  display: flex;
  flex-direction: column;
  align-items: ${props => (props.normal ? 'normal' : 'center')};
  margin: ${props => (props.margin ? props.margin : '0px')};
  width: 100%;
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  @media (max-width: 768px) {
    padding: 40px 20px;
  }
  @media (max-width: 640px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`
const FormWrapper = styled.form`
  display: flex;
  padding-top:20px;
  @media (max-width: 520px) {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    width: 100%;
    & > div > input {
      width: 100%;
      margin-bottom: 10px;
    }
    & > button {
      width: 100%;
      border-radius 4px;
    }
  }
`
const ButtonComponent = styled.button`
  width: ${props => (props.width ? props.width : 186)}px;
  height: ${props => (props.height ? props.height : 48)}px;
  background: ${props => (props.background ? props.background : '#333333')};
  border-radius: ${props => (props.radius ? props.radius : '4px')};
  border: ${props => (props.border ? props.border : 'none')};
  line-height: 1;
  letter-spacing: 1px;
  color: ${props => (props.color ? props.color : '#fff')};
  cursor: pointer;
  text-transform: ${props => (props.transform ? props.transform : 'uppercase')};
  font-family: Montserrat;
  font-size: 14px;
  line-height: 1;
  letter-spacing: 1px;
  box-shadow: ${props => (props.shadow ? props.shadow : 'none')};
  -webkit-tap-highlight-color: transparent;
  &:hover {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);
  }
  &:focus {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);
    outline: none;
  }
  @media (max-width: 768px) {
    height: 38px;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 1.1px;
  }
`
const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 992px) {
    flex-direction: column;
    width: 100%;
  }
  @media (max-width: 768px) {
    & > div {
      flex-basis: 100%;
      width: 100%;
    }
  }
`
const FromGroup = styled.div`
  width: 100%;
  margin-right: 20px;
  margin: 8px;
  input,
  textarea {
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    width: 100%;
  }
  input {
  }
  textarea {
    padding: 10px;
    min-height: 150px;
    :focus {
      box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);
      outline: none;
    }
  }
`
const ContactFrom = styled.div`
  margin-top: 50px;
`
const AddressWrap = styled.div`
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  margin-top: 20px;
  margin-left: 30px;

  @media (max-width: 768px) {
    margin-left: 0px;
  }
`
const AddressContent = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 0;
  a {
    color: #000;
  }
  > span {
    margin-right: 10px;
  }
  p {
    font-size: 14px;
    color: #555;
    font-weight: 500;
    margin-bottom: 5px;
  }
  p span {
    font-weight: bold;
    display: block;
    font-size: 16px;
    color: #000;
  }
`
export const Button = props => {
  return (
    <ButtonComponent
      color={props.color}
      height={props.height}
      width={props.width}
      background={props.background}
      border={props.border}
      radius={props.radius}
      {...props}>
      {props.title}
    </ButtonComponent>
  )
}
class UxUi extends Component {
  state = {
    collapse: false,
    MobileLogo: true,
    MobileLogoText: 'View More',
    selected: 'V'
  }
  render() {
    const { selected } = this.state
    console.log(selected)
    return (
      <Fragment>
        <Header />
        <ContentWrapper>
          <TopWrapper>
            <HeaderParagraph
              headerColor={'#333333'}
              headerFontSize={'38px'}
              header={'UX/UI'}
              paragraph={
                '8om Internet helps businesses serve their audience better by laying out their visions in an aesthetic and interactive way.'
              }
            />
          </TopWrapper>
          <ImageWrapper>
            <img src={require('../static/uiux.jpg')} alt="Services" />
          </ImageWrapper>
          <Container padding={'80px 0px'}>
            <ContainerTitle>Specialisation</ContainerTitle>
            <ContainerSubTitle>
              Let’s have a look at how our organization can create the best UI/UX for your users.
            </ContainerSubTitle>
            <SpecializationWrapper>
              <div>
                <CardComponent
                  img={require('../static/ui.svg')}
                  alt="UI Design"
                  smallHeading="UI Design"
                  description="End-user needs are skillfully satisfied according to your brand’s unique
                  context resulting into appealing designs that create a bond with your user."
                />
                <CardComponent
                  img={require('../static/ux.svg')}
                  alt="UX Design"
                  smallHeading="UX Design"
                  description="We deliver an engaging, immersive and subtle UX design that inspires your
                  audience to turn into valuable customers."
                />
                <CardComponent
                  img={require('../static/audit.svg')}
                  alt="Design Usability Audit"
                  smallHeading="Design Usability Audit"
                  description="Our analysis sees to it that your efforts bear fruitful results by evaluating what
                  works and what not. Best designs are a result of repetitive deliberate audits."
                />
                <CardComponent
                  img={require('../static/motion.svg')}
                  alt="Motion Graphics"
                  smallHeading="Motion Graphics"
                  description="We infuse life to your stories through adept motion graphics that make
                  staggering videos to take your message to the next level."
                />
                <CardComponent
                  img={require('../static/mobile.svg')}
                  alt="Mobile App Design"
                  smallHeading="Mobile App Design"
                  description="We craft responsive, user-centric designs that create an everlasting impact
                  on users which hooks them up to utilise your services."
                />
                <CardComponent
                  img={require('../static/typepo.svg')}
                  alt="Typography"
                  smallHeading="Typography"
                  description="Effect your reader’s visceral response by our skilled attention to the
                  typography of your text which helps make an evocative statement for your
                  brand."
                />
              </div>
            </SpecializationWrapper>
          </Container>
          <TopWrapper>
            <HeaderParagraph
              headerColor={'#333333'}
              headerFontSize={'38px'}
              header={'Get In Touch'}
              paragraph={'Sent us a message'}
            />

            <FlexContainer>
              <ContactFrom>
                <form action="https://formspree.io/harsh@8om.io" method="POST">
                  <FlexContainer>
                    <FromGroup>
                      <Input type="name" icon="user" name="Name" placeholder="Name" changeColor={'#35cc62'} required />
                    </FromGroup>
                    <FromGroup>
                      <Input
                        type="email"
                        name="_replyto"
                        icon="email"
                        placeholder="Email"
                        changeColor={'#35cc62'}
                        onChange={this.handleChange}
                        value={this.state.email}
                        required
                      />
                    </FromGroup>
                  </FlexContainer>
                  <FlexContainer>
                    <FromGroup>
                      <Input
                        type="phone"
                        name="contact"
                        icon="contact"
                        placeholder="Phone"
                        changeColor={'#35cc62'}
                        required
                      />
                    </FromGroup>
                  </FlexContainer>
                  <FlexContainer>
                    <FromGroup>
                      <textarea name="textarea" id="" placeholder="Your message type here" />
                    </FromGroup>
                  </FlexContainer>
                  <input type="hidden" name="_next" value="/" />
                  <FromGroup>
                    <Button type="submit" title="Submit" />
                  </FromGroup>
                </form>
              </ContactFrom>

              <AddressWrap>
                <AddressContent>
                  <span>
                    <Icon icon="contact" />
                  </span>
                  <p>
                    Phone
                    <span>
                      <a href="tel:+918076157787"> +91 8076157787</a>
                    </span>
                  </p>
                </AddressContent>
                <AddressContent>
                  <span>
                    <Icon icon="email" />
                  </span>
                  <p>
                    Email
                    <span>
                      <a href="mailto:harsh@8om.io"> harsh@8om.io</a>
                    </span>
                  </p>
                </AddressContent>
                <AddressContent>
                  <span>
                    <Icon icon="website" />
                  </span>
                  <p>
                    Website
                    <span>8om.io</span>
                  </p>
                </AddressContent>
                {/*   <AddressContent>
                  <span>
                    <Icon icon="location" />
                  </span>
                   <p>
                    Location
                    <span>
                      3rd Floor, Plot No. 8 Balaji Estate,
                      <br /> Guru Ravidas Marg, Kalkaji,
                      <br /> New Delhi, Delhi 110019
                    </span>
                  </p>
                </AddressContent> */}
              </AddressWrap>
            </FlexContainer>
          </TopWrapper>
          <Container2 normal background={'#fafbfc'} padding={'80px 0 80px 0'}>
            <ContainerTitle>Our Clients Around The World</ContainerTitle>
            <ContainerSubTitle>
              Our clients are valuable to us and we’re always inspired by them and their need to make their business
              better.
            </ContainerSubTitle>
            <Backgroundwrapper>
              <OurClient>
                <ul>
                  <li>
                    <img src={require('../static/client_logo/teafloor.png')} alt="Teafloor" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/creatanium.png')} alt="Cretanium" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/munafamart.png')} alt="Munafamart" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/beccos.jpg')} alt="Beccos" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/greenchoice.png')} alt="Greenchoice" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/bng.png')} alt="BnG" />
                  </li>
                </ul>
              </OurClient>
            </Backgroundwrapper>
          </Container2>
        </ContentWrapper>
        <BodyWrapper>
          <Footer />
          <MobileFooter />
        </BodyWrapper>
      </Fragment>
    )
  }
}
export default withRouter(UxUi)



// WEBPACK FOOTER //
// ./src/pages/UxUi.js